import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { BusinessCategoryComponent } from '../../components/business-category/business-category.component';

@Injectable({
    providedIn: 'root'
})
export class BusinessCategoryEditGuard implements CanDeactivate<BusinessCategoryComponent> {
    canDeactivate(component: BusinessCategoryComponent): Observable<boolean> | Promise<boolean> | boolean {
        if (component.frmEditBusinessCategory.touched && component.frmEditBusinessCategory.dirty) {
            return confirm(`Are you sure you want to navigate away and discard your changes?`);
        }
        return true;
    }
}

